import type { HotelAutocompleteOption } from '../types/types';
import { createWhitelabelUrl } from '../../../hotel/kayakWhitelabel';
import type { HotelRoom } from '../types/HotelRoom';

type Props = {
    destinationContext?: HotelAutocompleteOption;
    startDate?: Date;
    endDate?: Date;
    rooms: HotelRoom[];
};

export const HotelHiddenInputs = ({ destinationContext, startDate, endDate, rooms }: Props) => (
    <input
        data-testid="whiteLabelUrl"
        type="hidden"
        name="url"
        value={createWhitelabelUrl(destinationContext, startDate, endDate, rooms)}
    />
);
